__turbopack_context__.v({
  "availability": "PlanMatrix-module-scss-module__F_diqa__availability",
  "bundle-offer-content": "PlanMatrix-module-scss-module__F_diqa__bundle-offer-content",
  "bundle-offer-heading": "PlanMatrix-module-scss-module__F_diqa__bundle-offer-heading",
  "description": "PlanMatrix-module-scss-module__F_diqa__description",
  "desktop": "PlanMatrix-module-scss-module__F_diqa__desktop",
  "discount-notice-bolded": "PlanMatrix-module-scss-module__F_diqa__discount-notice-bolded",
  "discount-notice-container": "PlanMatrix-module-scss-module__F_diqa__discount-notice-container",
  "discount-notice-wrapper": "PlanMatrix-module-scss-module__F_diqa__discount-notice-wrapper",
  "feature-list": "PlanMatrix-module-scss-module__F_diqa__feature-list",
  "is-selected": "PlanMatrix-module-scss-module__F_diqa__is-selected",
  "mobile": "PlanMatrix-module-scss-module__F_diqa__mobile",
  "pick-button": "PlanMatrix-module-scss-module__F_diqa__pick-button",
  "plan": "PlanMatrix-module-scss-module__F_diqa__plan",
  "plans": "PlanMatrix-module-scss-module__F_diqa__plans",
  "price": "PlanMatrix-module-scss-module__F_diqa__price",
  "pricing": "PlanMatrix-module-scss-module__F_diqa__pricing",
  "pricing-overview": "PlanMatrix-module-scss-module__F_diqa__pricing-overview",
  "pricing-toggle": "PlanMatrix-module-scss-module__F_diqa__pricing-toggle",
  "pricing-toggle-wrapper": "PlanMatrix-module-scss-module__F_diqa__pricing-toggle-wrapper",
  "primary-pick-button": "PlanMatrix-module-scss-module__F_diqa__primary-pick-button",
  "recommended": "PlanMatrix-module-scss-module__F_diqa__recommended",
  "single-price": "PlanMatrix-module-scss-module__F_diqa__single-price",
  "table-wrapper": "PlanMatrix-module-scss-module__F_diqa__table-wrapper",
  "wrapper": "PlanMatrix-module-scss-module__F_diqa__wrapper",
});
